import { render, staticRenderFns } from "./PsiSimpleList.vue?vue&type=template&id=53610db1&scoped=true&"
import script from "./PsiSimpleList.vue?vue&type=script&lang=js&"
export * from "./PsiSimpleList.vue?vue&type=script&lang=js&"
import style0 from "./PsiSimpleList.vue?vue&type=style&index=0&id=53610db1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53610db1",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
installComponents(component, {VList,VListItem,VListItemContent})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53610db1')) {
      api.createRecord('53610db1', component.options)
    } else {
      api.reload('53610db1', component.options)
    }
    module.hot.accept("./PsiSimpleList.vue?vue&type=template&id=53610db1&scoped=true&", function () {
      api.rerender('53610db1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lib/src/components/lists/PsiSimpleList.vue"
export default component.exports